import { AfterContentInit, Component, OnInit } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { AuthService } from 'src/shared/service/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { AbstractDataProvider } from '../AbstractDataProvider';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import { GetSecurityQuestionsModel } from '../../shared/model/interfaces';
import { finalize } from 'rxjs/operators';
import {getErrorMessageText} from '../helper';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [DictionaryPipe]
})
export class ForgotPasswordComponent implements OnInit, AfterContentInit {
  userId: string;
  display = false;
  displaySuccessMessage: boolean;
  alertMessage: string;
  clientCode: string;
  clientName: string;
  clientPhoneNumber: string;
  bgImageUrl: string;

  constructor(
    public rest: RestService,
    private authService: AuthService,
    private ngxService: NgxUiLoaderService,
    private abstractDataProvider: AbstractDataProvider,
    private route: ActivatedRoute,
    private dictionaryPipe: DictionaryPipe
  ) {
  }

  ngOnInit() {
    this.bgImageUrl = this.authService.clientBackgroundImageUrl;
    this.authService.accessTokenRemovedSubj.next(true);

  }

  ngAfterContentInit() {
    this.clientCode = this.authService.clientCode;
    this.clientName = this.authService.wpCompanyName;
    this.clientPhoneNumber = this.authService.wpContactPhone;

  }

  submit() {
    if (!this.userId) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_USERNAME');
      return;
    }

    this.checkSecurityQuestions();
  }

  hidePopupAndNavigateHome() {
    this.displaySuccessMessage = false;
    this.authService.navigateToLogin();
  }

  promptEmailSentMessage() {
    this.displaySuccessMessage = true;
    return;
  }

  onConfirm() {
    this.display = false;
    this.authService.navigateToLogin();
  }


  cancel() {
    this.authService.navigateToLogin();
  }

  private checkSecurityQuestions() {
    this.ngxService.start();

    const dto = {
      UserId: this.userId,
      SendResetPasswordEmailIfQuestionsAreEmpty: true
    };
    const url = 'api/Accounts/GetSecurityQuestions';
    this.abstractDataProvider.postData(dto, url)
      .pipe(finalize(() => this.ngxService.stop())).subscribe(
      (d: {Data: GetSecurityQuestionsModel}) => {
        const data = d.Data;
        if (data && data.EmailSentTo) {
          this.displaySuccessMessage = true;
        } else {
          const params = {
            userId: this.userId,
            question_1: data.Question1,
            question_2: data.Question2,
            question_3: data.Question3,
          };
          this.authService.navigateToUrl('security-answers', params);
        }
      },
      (error) => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );
  }

}
